@if (pageStatus === "saveError" && pageError) {
    <admin-error [error]="pageError"></admin-error>
}

<div class="header">
    <div class="actions">
        @if (selectedFile) {
            <button
                mat-stroked-button
                color="warn"
                (click)="deleteFile(selectedFile)"
                [disabled]="pageStatus === 'saving'"
            >
                <mat-icon>delete</mat-icon>
                Delete file
            </button>
        }
        @if (selectedFile) {
            <input
                #singleFileUploader
                type="file"
                (change)="uploadSelectedFileContent(selectedFile.filename, $any($event.target).files)"
                [accept]="acceptedUploadFileTypes.join(',')"
                style="display: none"
            />
            <button mat-stroked-button (click)="singleFileUploader.click()">
                <mat-icon>upload</mat-icon>
                Upload...
            </button>
        }
        @if (selectedFile) {
            <admin-save-button
                [pageStatus]="pageStatus"
                (save)="save(selectedFile)"
                [useContent]="true"
                [disabled]="!isFileModified(selectedFile)"
            >
                <mat-icon>upload</mat-icon>&nbsp; Save File
            </admin-save-button>
        }
        <admin-save-button
            [pageStatus]="pageStatus"
            (save)="saveAll()"
            [useContent]="true"
            [disabled]="!isFileNotSaved()"
        >
            <mat-icon>save</mat-icon>&nbsp; Save All
        </admin-save-button>
    </div>
</div>

<div class="files">
    <div class="file-list">
        <mat-nav-list>
            @for (file of assetEditorInformation; track file) {
                <div class="asset-row">
                    <a mat-list-item tabindex="0" [activated]="selectedFile === file" appInteract (interact)="selectFile(file)">
                        <span class="filename" [matTooltip]="file.filename">
                            <mat-icon>file_open</mat-icon>
                            {{ file.filename }}
                            @if (isFileModified(file)) {
                                *
                            }
                        </span>
                    </a>
                    @if (fileCustomActions.length) {
                        <button mat-icon-button [matMenuTriggerFor]="copyMenu" (click)="menuFileContext = file" matTooltip="Copy asset URL"
                                aria-label="Copy asset URL">
                            <mat-icon>more_vert</mat-icon>
                        </button>

                        <mat-menu #copyMenu="matMenu">
                            @for (action of fileCustomActions; track action.name) {
                                <button mat-menu-item (click)="customAction.emit({actionName: action.name, file: file})">
                                    <mat-icon>{{ action.icon }}</mat-icon>
                                    <span>{{ action.label }}</span>
                                </button>
                            }
                        </mat-menu>
                    }
                </div>
            }
        </mat-nav-list>
        <div class="actions">
            <button mat-stroked-button (click)="addNewFile()">
                <mat-icon>add</mat-icon>
                Add file
            </button>
            <input
                #multipleFilesUploader
                type="file"
                multiple="multiple"
                (change)="uploadFromFiles($any($event.target).files)"
                [accept]="acceptedUploadFileTypes"
                style="display: none"
            />
            <button mat-stroked-button (click)="multipleFilesUploader.click()">
                <mat-icon>upload</mat-icon>
                Upload files...
            </button>
        </div>
    </div>
    @if (selectedFile !== undefined) {
        <div class="file-editor">
            @if (isTextEditableFile(selectedFile)) {
                <div class="editor">
                    <code-editor
                        [(ngModel)]="fileContents[selectedFile.filename]"
                        theme="dark"
                        setup="basic"
                        [languages]="languages"
                        [language]="getLanguage(this.fileMimeTypes[selectedFile.filename])"
                        (keydown)="handleSaveEditor($event, selectedFile)"
                    ></code-editor>
                </div>
            }
            @if (isImage(selectedFile)) {
                <img [src]="selectedFile.url" [alt]="'Preview of the file ' + selectedFile.filename" />
            }
            @if (pageStatus === "loadError" && pageError) {
                <admin-error [error]="pageError"></admin-error>
            }
        </div>
    } @else {
        <span class="no-selected-file">Select a file to edit it</span>
    }
</div>
